export default {
  title: {
    female: {
      en: 'Top {name} women perfumes',
    },
    male: {
      en: 'Top {name} men colognes',
    },
  },
}
